
SJ.LocationManager = {};

SJ.LocationManager.changeLocation = (locationName, callback) => {
    SJ.loadVariablesFromFile(locationName, () => {
      callback();
    });
}